export function getEligibilityTone(percent) {
  const value = Number(percent) || 0;
  if (value >= 75) return "high";
  if (value >= 50) return "medium";
  return "low";
}

export function formatEligibilityBreakdown(breakdown = {}) {
  const lines = [];

  if (breakdown.primary_skills) {
    lines.push(
      `Primary skills: ${breakdown.primary_skills.matched}/${breakdown.primary_skills.total} (${breakdown.primary_skills.percent}%)`
    );
  }
  if (breakdown.secondary_skills) {
    lines.push(
      `Secondary skills: ${breakdown.secondary_skills.matched}/${breakdown.secondary_skills.total} (${breakdown.secondary_skills.percent}%)`
    );
  }
  if (breakdown.experience_total) {
    const req = breakdown.experience_total.required;
    lines.push(
      `Total experience: ${breakdown.experience_total.percent}% fit (min ${req}+ yrs, candidate ${breakdown.experience_total.candidate ?? "—"})`
    );
  }
  if (breakdown.experience_relevant) {
    const req = breakdown.experience_relevant.required;
    lines.push(
      `Relevant experience: ${breakdown.experience_relevant.percent}% fit (min ${req}+ yrs, candidate ${breakdown.experience_relevant.candidate ?? "—"})`
    );
  }
  if (breakdown.location) {
    lines.push(`Location fit: ${breakdown.location.percent}%`);
  }

  return lines;
}

export function getCandidateDisplayName(row) {
  return `${row?.candidate_firstname || ""} ${row?.candidate_lastname || ""}`.trim() || "Unnamed candidate";
}
